import {
  GET_LEADS_LIST,
  ADD_LEADS_LIST,
  UPDATE_LEADS_LIST,
  DELETE_LEADS_LIST,
} from "../types/leads-list";

const initialState = {
  leadsList: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LEADS_LIST:
      return {
        ...state,
        leadsList: payload,
      };
    case ADD_LEADS_LIST:
      return {
        ...state,
        leadsList: [payload, ...state.leadsList],
      };
    case UPDATE_LEADS_LIST:
      let list = state.leadsList.filter((list) => list.id === payload.id)[0];
      list.name = payload.name;
      return {
        ...state,
        leadsList: [...state.leadsList],
      };
    case DELETE_LEADS_LIST:
      let newList = [...state.leadsList].filter((list) => list.id !== payload);
      return {
        ...state,
        leadsList: [...newList],
      };
    default:
      return state;
  }
};

export default reducer;
